import { TextBase } from '@carboncopyco/ui';
import { Separator } from './Separator';

export interface FormLayoutProps {
  onSubmit: (event: React.FormEvent<HTMLFormElement>) => void;
  children?: React.ReactNode;
}

export const FormLayout = ({ onSubmit, children }: FormLayoutProps) => (
  <form
    onSubmit={(e) => {
      e.preventDefault();
      onSubmit?.(e);
    }}
    className="flex flex-col h-full"
  >
    {children}
  </form>
);

export interface FormLayoutHeaderProps {
  stepNumber?: number;
  instruction?: string;
}
const FormLayoutHeader = ({
  stepNumber,
  instruction,
}: FormLayoutHeaderProps) => {
  return (
    <div className="flex flex-col">
      {instruction && (
        <span className="flex gap-1.5 items-center px-5 pt-2.5">
          {!!stepNumber && (
            <div className="w-5 h-5 m-0.5 bg-ds-natural-400 text-white text-sm rounded-full flex flex-col items-center justify-center font-normal">
              {stepNumber}
            </div>
          )}
          <TextBase
            color="text-ds-natural-600"
            label={instruction}
          />
        </span>
      )}
      <span className="pt-5">
        <Separator />
      </span>
    </div>
  );
};

FormLayout.Header = FormLayoutHeader;

const FormLayoutContent = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-col flex-1 min-h-0 px-8">{children}</div>
);

FormLayout.Content = FormLayoutContent;

const FormLayoutFooter = ({ children }: { children: React.ReactNode }) => (
  <div className="flex flex-col gap-4 pb-5">
    <Separator />
    <div className="flex gap-2.5 items-center px-8">{children}</div>
  </div>
);

FormLayout.Footer = FormLayoutFooter;
